"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Bottom = void 0;
exports.CardBodyContainer = CardBodyContainer;
exports.CardList = CardList;
exports.CardModalContainer = CardModalContainer;
exports.CardModalContent = CardModalContent;
exports["default"] = exports.PlaceholderBottom = exports.NudgeCardBottom = exports.ModelMode = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _ArrowBack = _interopRequireDefault(require("@material-ui/icons/ArrowBack"));
var _ArrowForward = _interopRequireDefault(require("@material-ui/icons/ArrowForward"));
var _classnames = _interopRequireDefault(require("classnames"));
var _Button = _interopRequireDefault(require("../Button"));
var _react = _interopRequireWildcard(require("react"));
var _reactI18next = require("react-i18next");
var _GalleryBody = require("../ContactsGallery/GalleryBody");
require("./index.css");
var _excluded = ["children", "onPrevious", "onNext", "hasPrevious", "title", "header", "hasNext", "bottom", "className", "currIdx", "total", "listClassName", "style", "isNeedShadow"],
  _excluded2 = ["title", "hasNext", "onNext", "onPrevious", "hasPrevious", "bottom", "children", "cardDetail", "className", "onClose", "currIdx", "total", "style", "listClassName"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function CardModalContainer(_ref) {
  var children = _ref.children,
    bottom = _ref.bottom,
    _ref$isDetailMode = _ref.isDetailMode,
    isDetailMode = _ref$isDetailMode === void 0 ? false : _ref$isDetailMode;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "relative"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('relative', {
      'bg-card suggestedDetail': isDetailMode
    })
  }, children), /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('absolute bottom-0 w-full py-4 bg-card z-10', {
      invisible: !bottom || isDetailMode
    }),
    style: {
      boxShadow: '0px 3px 20px #00000029'
    }
  }, bottom));
}
function CardList(_ref2) {
  var children = _ref2.children,
    onPrevious = _ref2.onPrevious,
    onNext = _ref2.onNext,
    _ref2$hasPrevious = _ref2.hasPrevious,
    hasPrevious = _ref2$hasPrevious === void 0 ? true : _ref2$hasPrevious,
    title = _ref2.title,
    header = _ref2.header,
    _ref2$hasNext = _ref2.hasNext,
    hasNext = _ref2$hasNext === void 0 ? true : _ref2$hasNext,
    bottom = _ref2.bottom,
    className = _ref2.className,
    currIdx = _ref2.currIdx,
    total = _ref2.total,
    listClassName = _ref2.listClassName,
    style = _ref2.style,
    _ref2$isNeedShadow = _ref2.isNeedShadow,
    isNeedShadow = _ref2$isNeedShadow === void 0 ? true : _ref2$isNeedShadow,
    reset = (0, _objectWithoutProperties2["default"])(_ref2, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "w-full h-70vh 2xl:h-60vh",
    style: {
      maxHeight: 800
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "absolute z-0 w-full h-full",
    style: {
      transform: 'scale(1.08, 0.85)'
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('w-20 h-full float-left', {
      invisible: !hasPrevious
    })
  }, /*#__PURE__*/_react["default"].createElement(GalleryPlaceholder, null)), /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('w-20 h-full float-right', {
      invisible: !hasNext
    })
  }, /*#__PURE__*/_react["default"].createElement(GalleryPlaceholder, null))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "absolute z-0 h-full",
    style: {
      width: '130%',
      left: '-15%'
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "h-full flex items-center justify-between"
  }, /*#__PURE__*/_react["default"].createElement(_GalleryBody.NavButton, {
    className: (0, _classnames["default"])({
      invisible: !hasPrevious
    }),
    onClick: onPrevious
  }, /*#__PURE__*/_react["default"].createElement(_ArrowBack["default"], {
    fontSize: "large"
  })), /*#__PURE__*/_react["default"].createElement(_GalleryBody.NavButton, {
    className: (0, _classnames["default"])({
      invisible: !hasNext
    }),
    onClick: onNext
  }, /*#__PURE__*/_react["default"].createElement(_ArrowForward["default"], {
    fontSize: "large"
  })))), title ? /*#__PURE__*/_react["default"].createElement("div", {
    className: "text-2xl pl-13 pt-8 font-bold bg-app dark:bg-card"
  }, title) : null, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('bg-app dark:bg-card w-full h-full', className),
    style: style
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('w-full h-full', listClassName, {
      'shadow-lg dark:shadow-deep': isNeedShadow
    })
  }, children)), /*#__PURE__*/_react["default"].createElement("div", {
    className: "absolute bottom-0 w-full -mb-6"
  }, /*#__PURE__*/_react["default"].createElement(_GalleryBody.Indicator, {
    currIdx: currIdx,
    total: total
  }))));
}
function CardBodyContainer(_ref3) {
  var children = _ref3.children,
    onPrevious = _ref3.onPrevious;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "relative"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "absolute z-0 h-full",
    style: {
      width: '130%',
      left: '-15%'
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "h-full flex items-start justify-between"
  }, /*#__PURE__*/_react["default"].createElement(_GalleryBody.NavButton, {
    disabled: false,
    onClick: onPrevious
  }, /*#__PURE__*/_react["default"].createElement(_ArrowBack["default"], {
    fontSize: "large"
  })))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "px-8 relative z-0 h-70vh overflow-y-auto"
  }, children));
}
var GalleryPlaceholder = function GalleryPlaceholder() {
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "h-full bg-card flex items-end"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "w-full h-20 shadow-hover dark:shadow-lg-t"
  }));
};
var Bottom = exports.Bottom = function Bottom(_ref4) {
  var onIgnore = _ref4.onIgnore,
    onBlock = _ref4.onBlock,
    className = _ref4.className,
    style = _ref4.style,
    _ref4$disabled = _ref4.disabled,
    disabled = _ref4$disabled === void 0 ? false : _ref4$disabled;
  var _useTranslation = (0, _reactI18next.useTranslation)(),
    t = _useTranslation.t;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('flex flex-1 pl-12 min-w-0 my-4', className),
    style: _objectSpread({}, style)
  }, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    color: "secondary",
    className: "mr-8",
    disabled: disabled,
    style: {
      width: 170
    },
    onClick: function onClick() {
      return onIgnore();
    }
  }, t('button.ignore')), /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    disabled: disabled,
    style: {
      width: 170
    },
    onClick: function onClick() {
      return onBlock();
    }
  }, t('button.block')));
};
var PlaceholderBottom = exports.PlaceholderBottom = function PlaceholderBottom() {
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "h-24"
  });
};
var ModelMode = exports.ModelMode = {
  LIST: 'list',
  DETAIL: 'detail'
};
function CardModalContent(_ref5, ref) {
  var title = _ref5.title,
    hasNext = _ref5.hasNext,
    onNext = _ref5.onNext,
    onPrevious = _ref5.onPrevious,
    hasPrevious = _ref5.hasPrevious,
    bottom = _ref5.bottom,
    children = _ref5.children,
    cardDetail = _ref5.cardDetail,
    className = _ref5.className,
    onClose = _ref5.onClose,
    currIdx = _ref5.currIdx,
    total = _ref5.total,
    style = _ref5.style,
    listClassName = _ref5.listClassName,
    rest = (0, _objectWithoutProperties2["default"])(_ref5, _excluded2);
  var _useState = (0, _react.useState)(ModelMode.LIST),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    mode = _useState2[0],
    setMode = _useState2[1];
  (0, _react.useImperativeHandle)(ref, function () {
    return {
      mode: mode,
      setModeDetail: function setModeDetail() {
        return setMode(ModelMode.DETAIL);
      },
      setModeList: function setModeList() {
        return setMode(ModelMode.LIST);
      }
    };
  });
  return /*#__PURE__*/_react["default"].createElement(CardModalContainer, {
    bottom: bottom,
    isDetailMode: mode === ModelMode.DETAIL
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('top-0', {
      'invisible absolute overflow-hidden w-1': mode !== ModelMode.LIST,
      relative: mode === ModelMode.LIST
    })
  }, /*#__PURE__*/_react["default"].createElement(CardList, (0, _extends2["default"])({}, rest, {
    style: style,
    listClassName: listClassName,
    currIdx: currIdx,
    total: total,
    className: className,
    title: title,
    hasNext: hasNext,
    hasPrevious: hasPrevious,
    onNext: onNext,
    onPrevious: onPrevious
  }), typeof children === 'function' ? children({
    setModeDetail: function setModeDetail() {
      return setMode(ModelMode.DETAIL);
    }
  }) : children)), mode !== ModelMode.LIST ? /*#__PURE__*/_react["default"].createElement("div", {
    className: "relative top-0"
  }, cardDetail({
    setModeList: function setModeList() {
      return setMode(ModelMode.LIST);
    }
  })) : null);
}
var NudgeCardBottom = exports.NudgeCardBottom = function NudgeCardBottom(_ref6) {
  var onDismiss = _ref6.onDismiss,
    onReply = _ref6.onReply,
    className = _ref6.className,
    style = _ref6.style,
    _ref6$disabled = _ref6.disabled,
    disabled = _ref6$disabled === void 0 ? false : _ref6$disabled;
  var _useTranslation2 = (0, _reactI18next.useTranslation)(),
    t = _useTranslation2.t;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('flex flex-1 pl-12 min-w-0 my-4', className),
    style: _objectSpread({}, style)
  }, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    color: "secondary",
    className: "mr-8",
    disabled: disabled,
    style: {
      width: 170
    },
    onClick: function onClick() {
      return onDismiss();
    }
  }, t('button.dismiss')), /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    disabled: disabled,
    style: {
      width: 170
    },
    onClick: function onClick() {
      return onReply();
    }
  }, t('button.reply')));
};
var _default = exports["default"] = /*#__PURE__*/(0, _react.forwardRef)(CardModalContent);
//# sourceMappingURL=CardModal.js.map